import React from "react";
import { connect } from "react-redux";
import PhotoEditorContainer from "../../PhotoEditor/PhotoEditorContainer";

import { CarouselProvider, Slider, Slide } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

import { Typography, Box, Paper } from "@material-ui/core";

const SlideStyle = {
  margin: "5px",
  boxShadow: "1px 2px 4px rgba(0,0,0,.35)",
  borderRadius: 8,
  overflow: "hidden",
  background: "#fff",
};

class AtletePhotosView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleSlidesBase: window.innerWidth > 992 ? 5 : 3,
    };
  }

  componentDidMount() {
    this._onResize = () => {
      const visibleSlidesBase = window.innerWidth > 992 ? 5 : 3;
      if (visibleSlidesBase !== this.state.visibleSlidesBase) {
        this.setState({ visibleSlidesBase });
      }
    };
    window.addEventListener("resize", this._onResize, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._onResize);
  }

  arrayPhotos = (arrayPhotosProps) => {
    const photosArray = { data: [], medio: 0, cantidad: 0 };
    if (!arrayPhotosProps) return photosArray;

    let x = 0;
    const fhm = this.props?.resultado?.fhm;

    for (const i in arrayPhotosProps) {
      const p = arrayPhotosProps[i];
      x += 1;

      // Calcula medio (0-based) comparando fechas "YYYY-MM-DD HH:mm:ss"
      if (p?.horaAjustada && fhm) {
        const horaAjustadaSplit = String(p.horaAjustada).split(" ");
        const fhmSplit = String(fhm).split(" ");

        if (horaAjustadaSplit.length >= 2 && fhmSplit.length >= 2) {
          const dPhoto = new Date(
            `${horaAjustadaSplit[0]}T${horaAjustadaSplit[1]}`
          );
          const dFhm = new Date(`${fhmSplit[0]}T${fhmSplit[1]}`);

          if (!isNaN(dPhoto.getTime()) && !isNaN(dFhm.getTime()) && dPhoto < dFhm) {
            photosArray.medio = x - 1; // ✅ 0-based
          }
        }
      }

      photosArray.data.push(p);
    }

    photosArray.cantidad = photosArray.data.length;

    // ✅ Clamp por seguridad (evita currentSlide fuera de rango)
    photosArray.medio = Math.max(
      0,
      Math.min(photosArray.medio, Math.max(0, photosArray.cantidad - 1))
    );

    return photosArray;
  };

  render() {
    // Si todavía no hay data, no pintes nada
    if (this.props.atletePhotos == null) return <div />;

    const photosArray = this.arrayPhotos(this.props.atletePhotos);
    const totalSlides = photosArray.data.length;

    // ✅ Si no hay fotos, NO renderices CarouselProvider (evita crash interno)
    if (!totalSlides) {
      return (
        <Box mt={2}>
          <hr />
          <Typography variant="h6" color="textSecondary">
            No hay fotos para mostrar.
          </Typography>
        </Box>
      );
    }

    // ✅ visibleSlides nunca debe exceder totalSlides
    const visibleSlides = Math.max(
      1,
      Math.min(this.state.visibleSlidesBase, totalSlides)
    );

    // ✅ currentSlide siempre dentro del rango
    const currentSlide = Math.max(0, Math.min(photosArray.medio, totalSlides - 1));

    // Centrar cuando hay pocas fotos
    const centerTray = totalSlides <= visibleSlides;

    return (
      <Box mt={2}>
        <hr />

        <Box mb={1}>
          <Typography variant={"h4"} color="primary">
            Fotos del atleta
          </Typography>
        </Box>

        <Paper style={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
          <Box p={1}>
            <CarouselProvider
              naturalSlideWidth={200}
              naturalSlideHeight={220}
              totalSlides={totalSlides} // ✅ real
              currentSlide={currentSlide} // ✅ clamp
              step={1}
              visibleSlides={visibleSlides} // ✅ clamp
              isIntrinsicHeight
              dragEnabled
              touchEnabled
            >
              <Box
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  overflow: "hidden",
                  display: centerTray ? "flex" : "block",
                  justifyContent: centerTray ? "center" : "flex-start",
                }}
              >
                <Box style={{ width: "100%", maxWidth: "100%" }}>
                  <Slider>
                    {photosArray.data.map((photo, index) => (
                      <Slide index={index} key={index} style={SlideStyle}>
                        <Box p={1}>
                          <PhotoEditorContainer
                            buttomLabel={"Abrir Editor"}
                            title={"Editor"}
                            resultado={this.props.resultado}
                            urlPhoto={photo.url}
                          />
                        </Box>

                        <img
                          src={photo.urlThumb}
                          alt="foto"
                          style={{
                            display: "block",
                            width: "100%",
                            height: 180,
                            objectFit: "cover",
                          }}
                          loading="lazy"
                        />
                      </Slide>
                    ))}
                  </Slider>
                </Box>
              </Box>
            </CarouselProvider>
          </Box>
        </Paper>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  atletePhotos: state.atlete.atletePhotos,
});

export default connect(mapStateToProps)(AtletePhotosView);